export enum Lang {
  'fr' = 'fr',
  'en' = 'en',
  'de' = 'de',
  'es' = 'es',
  'nl' = 'nl',
}
